module.exports = __webpack_public_path__ + "img/img_bg_sel.fb6c0d61.gif";